/** Shared shell top bar sizing — height token lives in globals.css (`--shell-header-height`). */
export const SHELL_HEADER_BAR_CLASSNAME =
  'flex min-h-[var(--shell-header-height)] shrink-0 items-center gap-3 bg-background px-4 py-2.5 sm:px-5';

/** Taller shell header when a subtitle sits under the title (Studio console pages). */
export const SHELL_HEADER_BAR_EXTENDED_CLASSNAME =
  'flex min-h-[var(--shell-header-height-extended)] shrink-0 items-center gap-3 bg-background px-4 py-4 sm:px-5';

export const SHELL_HEADER_SCROLL_OFFSET_CLASSNAME = 'min-h-[calc(100dvh-var(--shell-header-height))]';
export const SHELL_HEADER_MAX_HEIGHT_CLASSNAME = 'max-h-[calc(100dvh-var(--shell-header-height))]';
